import { useEffect, useState } from "react";

function InputButtonGroup({ options, onChange, value, disabled }) {
  const [selectedOption, setSelectedOption] = useState(value);

  function handleClick(selection) {
    setSelectedOption(selection);
    onChange(selection);
  }

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  return options.map((o) => (
    <button
      type="button"
      value={o.value}
      disabled={disabled}
      selected={selectedOption === o.value}
      onClick={() => handleClick(o.value)}
      key={o.value}
      className={`select-button ${selectedOption === o.value ? "active" : ""}`}
    >
      {o.label}
    </button>
  ));
}

export default InputButtonGroup;
